<template>
  <v-container class="component_main">
    <v-row>
      <v-col class="pb-0" cols="12" sm="6" md="6">
        <h2 class="authorizer-title">MOTIVOS DE GLOSA</h2>
      </v-col>
      <v-col class="d-flex justify-end pb-0" cols="12" sm="6" md="6">
        <v-btn v-if="list.length" color="primary" text @click="getFile()">
          <v-icon small class="pr-2">fa-download</v-icon>
          Exportar
        </v-btn>
      </v-col>
      <v-col class="" cols="12" sm="12" md="12">
        <v-data-table
          :headers="headers"
          :items="list"
          hide-default-footer
          @page-count="pageCount = $event"
          dense
          :items-per-page="10"
          :page.sync="page"
          class="motivosGlosaTable"
        >
          <!-- sortBy="valor_glosado"
          :sortDesc="true" -->
        <template v-slot:item.origem="{item}">
                {{ item.origem.toUpperCase()}}
          </template>
          <template v-slot:item.perc="{item}">
                {{ item.perc | formatPrice }}
          </template>

          <template v-slot:item.valor_glosado="{item}">
            <b>R$ {{ item.valor_glosado | formatPrice }}</b>
            <v-btn
              icon
              class="ml-2"
              x-small
              @click="setTab('tab-edit-recursos-reg', item.motivo_glosa)"
            >
              
              <v-icon x-small color="primary">fa-pencil-alt</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-pagination class="no-box-shadow" v-model="page" :length="pageCount"></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  data() {
    return {
      page: 1,
      pageCount: 0,
      headers: [
        { text: "Motivo de glosa", value: "descricao_motivo_glosa", sortable: false },
        { text: "Código", value: "motivo_glosa", align: 'center', sortable: false },
        // { text: "Origem", value: "origem", sortable: true },
        { text: "%", value: "perc", align: 'center', sortable: true }, // Pedir pro Victor
        { text: "Qtde. guias", value: "qtd_guias", class: 'max-width-85', align: 'center', sortable: true }, // Pedir pro Victor
        { text: "Qtde. itens", value: "qtd_itens", class: 'max-width-85', align: 'center', sortable: true }, // Pedir pro Victor
        { text: "Valor", value: "valor_glosado", align: 'right', sortable: true },
      ]
    };
  },
  watch:{
    list(){
      this.page = 1
    }
  },
  props: {
    setTab: Function,
    list: Array,
    getFile: Function
  },
  computed: {
    ...mapState({
      operadoras: (state) => state.permissions.operadoras
    }),
  },
  methods: {
    ...mapActions('autorizador', [
      "setFilter"
    ]),
    downloadList() {
    },

  }
};
</script>

<style>
 .no-box-shadow,
  .no-box-shadow * {
    box-shadow: 0 0 0 0 !important;
  }
.max-width-85{
  max-width: 85px;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.theme--light.v-data-table.motivosGlosaTable > .v-data-table__wrapper > table > thead > tr > th:nth-child(1),
.theme--light.v-data-table.motivosGlosaTable > .v-data-table__wrapper > table > tbody > tr > td:nth-child(1) {
    max-width: 600px;
    text-overflow: ellipsis;
    overflow: hidden;
}
</style>
